import angular from 'angular';

class ModalResendInvitationCtrl {
    /*@ngInject*/
    constructor(invitedEntitySvc, logger, EMAIL_REGEXP) {
        this.invitedEntitySvc = invitedEntitySvc;
        this.logger = logger;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
    }

    resendInvitation() {
        let vm = this;
        this.invitedEntitySvc.resendInvitation(vm.resolve.invitation.id, vm.resolve.invitation.contactEmail).then(
            function () {
                vm.logger.success('Invitation envoyée avec succès');
                vm.modalInstance.close();
            },
            function () {
                vm.logger.error('Echec envoie invitation');
                vm.cancel();
            }
        );
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalResendInvitation', {
    templateUrl: require('./modal-resend-invitation.html'),
    controller: ModalResendInvitationCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
